import React from 'react';
import DashboardIEEM from './ieem/DashboardIEEM';

const Dashboard = () => <DashboardIEEM />;

export default Dashboard;
